import { ABOUTUSCONTENT_GET_LIST,ABOUTUSCONTENT_GET_LIST_SUCCESS,ABOUTUSCONTENT_GET_LIST_ERROR } from "../../../redux/contants";
import { all, fork, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { apiBaseUrl } from '../../../constants/defaultValues';


function* fetchAboutUsContentAPI() {
    // alert('saga')
    try {
        // const subscriberDetails = yield Axios.get(`Role/GetRoleList`).then(response => response.data);
        // alert("c")
          const config = {
            method: 'get',
            url: `${apiBaseUrl}OurJourney/GetOurJourneyList`,
            headers: { 
              'Accept': 'text/plain', 
              'Authorization': '<API Key>'
            }
          };
          const aboutdetails = yield axios(config).then(response => response.data.Data);
        
        // console.log(subscriberDetails,"============")
        yield put({ type: ABOUTUSCONTENT_GET_LIST_SUCCESS, data: aboutdetails });
    } catch (error) {
        yield put({ type: ABOUTUSCONTENT_GET_LIST_ERROR, error });
    }
}



export function* watchAboutUsContent() {
    // eslint-disable-next-line no-use-before-define
    yield takeEvery(ABOUTUSCONTENT_GET_LIST, fetchAboutUsContentAPI);

}



export default function* rootSaga() {
    yield all([
        fork(watchAboutUsContent)
        
    ]);
}